<template>
  
  <div id="facet-placeholder"> 

    <div class="trajectories-banner"><img src="assets/images/trajectories_banner.png" style="width: 100%;"></div>  

    <button class="ui button search-button" style="width:97%; margin:5px;" @click="searchObservationsButtonClick($event)">
      Search For Observations
    </button>

    <div class="ui segment" style="margin:5px; padding: 8px;">
      <div class="ui top attached label" style="padding: 8px;">Producer</div>
      <div v-if="getFacetClassification != null">
        <facet-component
          :facetElements="getFacetClassification.producerNames"
          :mutationName="'UPDATE_FILTERS_PRODUCER_NAMES'"
          style="resize: vertical; overflow-y:scroll; min-height:18px; height: 90px"
        ></facet-component>
      </div>
    </div>
    

    <div class="ui segment" style="margin:5px; padding: 8px;">
      <div class="ui top attached label">Date</div>
      <div style="height: 20px">
        <div class="trajectories-text" style="float: left;">Min Year:</div>
        <input type="text" id="minDate" value="" style="float:left; width: 100px; margin-left: 5px;">
        <div class="trajectories-text" style="float: left; margin-left: 15px;">Max Year:</div>
        <input type="text" id="maxDate" value="" style="float:left; width: 100px; margin-left: 5px;">
      </div>
    </div>

    <div class="ui segment" style="margin:5px; padding: 8px;">
      <div class="ui top attached label" style="padding: 8px;">Variable Names</div>
      <div v-if="getFacetClassification != null">
        <facet-component
          :facetElements="getFacetClassification.variableNamesFacet"
          :mutationName="'UPDATE_FILTERS_VARIABLE_NAMES'"
          style="resize: vertical; overflow-y:scroll; min-height:18px; height:100px;"
        ></facet-component>
      </div>
    </div>    

    <div class="ui segment" style="margin:5px; padding: 8px;">
      <div class="ui top attached label" style="padding: 8px;">Observed Property - Scientific Keyword Tags</div>

      <div>
        <div class="trajectories-text" style="float:left; width: 70px;">Match type:</div>
        <select style="font-size: 11px; margin-bottom: 2px;" @change="linkTypeChanged($event)">
          <option value="direct_tags">Directly tagged keywords</option>
          <option value="follow_links">All linked keywords</option>
        </select>
      </div>

      <div style="clear: both;">
        <div class="trajectories-text" style="float:left; width: 70px;">Onotolgy:</div>
        <select style="font-size: 11px; margin-bottom: 2px;" @change="ontologyChanged($event)">
          <option value="None">None</option>
          <option value="http://vocabs.lter-europe.net/EnvThes">EnvThes</option>
          <option value="https://gcmdservices.gsfc.nasa.gov">GCMD</option>
          <option value="http://www.eionet.europa.eu/gemet">Gemet</option>
          <option value="http://linked.earth/ontology">Linked Earth</option>
          <option value="https://w3id.org/ozcar-theia">OZCAR-THEIA</option>
        </select>
      </div>

<!--
      <div v-if="getFacetClassification != null">
        <facet-component
          :facetElements="getFacetClassification.keywordOntologiesFacet"
          :mutationName="'UPDATE_FILTERS_KEYWORD_ONTOLOGIES'"
          style="resize: vertical; overflow-y:scroll; min-height:18px; height:53px; margin-left: 3px; margin-bottom: 8px;"
        ></facet-component>
      </div>
-->

      <div class="trajectories-text">Scientific Keywords:</div>
      <div v-if="getFacetClassification != null" style="border: 1px solid #CCC;">
        <filter-by-keyword-component
          :keywordOntologies="getFacetClassification.keywordOntologiesFacet"
          :facetElements="getFacetClassification.keywordsFacet"
          :mutationName="'UPDATE_FILTERS_KEYWORDS'"
          style="resize: vertical; overflow:scroll; min-height:18px; height: 197px"
        ></filter-by-keyword-component>
      </div>
    </div>



    <div class="ui segment" style="margin:5px; padding:8px; padding-top:35px;">
      <div class="ui top attached label">Settings</div>
      <label class="trajectories-text">Map Object Clustering:</label>
      <select style="font-size: 11px;" @change="clusteringChanged($event)">
        <option value="clustering_on">On</option>
        <option value="clustering_off">Off</option>
      </select>
      <br/>

    </div>

  </div>
</template>

<script>
import mapComponent from "./map-component.vue";
import facetComponent from "./facet-components/facet-component.vue";
import filterByKeywordComponent from "./filter-by-keyword-component.vue";
import Vuex from "vuex";

    /**
     * This component contains 4 facetComponent sub-component (geologie, climates, producer, fundings)
     * Facet classification result is passed to each of them in order to diplay the name of the filter 
     * and the count of observation associated
     * The name of the Vuex Filter store mutation corresponding is also passed to each of the sub-component
     * in order for them to be able to call the mutation when one filter is checked
     */
export default {
  components: {
    facetComponent,
    filterByKeywordComponent
  },
  computed: {
    ...Vuex.mapGetters(["getFacetClassification", "getFilters", "getSettings"])
  },
  watch: {
    getFacetClassification() {
      this.updateVariableNames();
    }
  },
  methods: {
    searchObservationsButtonClick(event) {
      //console.log(this.getFilters.searchArea);
      this.getFilters.minDate = document.getElementById("minDate").value;
      this.getFilters.maxDate = document.getElementById("maxDate").value;
      console.log(document.getElementById("minDate").value);
      console.log(document.getElementById("maxDate").value);
      this.searchObservations(this.getFilters);
    },
    updateVariableNames() {

    },
    clusteringChanged($event) {
      if(event.srcElement.value == "clustering_on") {
          console.log("Turning clustering on");
          this.getSettings.clustering = true;
        } else {
          console.log("Turning clustering off");
          this.getSettings.clustering = false;
        }
    },
    linkTypeChanged(event) {
      console.log(this.getFilters.totalCount);
      console.log("linkTypeChanged");
      if(event.srcElement.value == "follow_links") {
        this.getFilters.keywordsLinkType.push("follow_skos_match_links");
      } else {
        this.getFilters.keywordsLinkType = [];
      }
      if(this.getFilters.totalCount> 0) {        
        this.searchObservations(this.getFilters);
      }
    },
    ontologyChanged(event) {
      console.log(this.getFilters.totalCount);
      console.log("ontologyChanged");
      if(event.srcElement.value == "None") {
        this.getFilters.keywordOntologies = [];
      } else {
        this.getFilters.keywordOntologies = [];
        this.getFilters.keywordOntologies.push(event.srcElement.value);
      }
      if(this.getFilters.totalCount> 0) {        
        this.searchObservations(this.getFilters);
      }
    },
    ...Vuex.mapActions(["initFacets","searchObservations"])
  },
  created() {
    /**
     * When the component is created the facet element are initialised using the whole database
     */
    this.initFacets();
  }
};
</script>

<style>
#facet-placeholder {
  position: absolute;
  height: 100%;
  max-height: 100%;
  width: 30%;
  left: 0;
  top: 0;
  background-color: rgba(52,112,101,0.05);;
  border-right-style: solid;
  border-right-width: 1px;
  border-color: grey;
  overflow-y:auto;
  /*resize: horizontal;
  overflow: auto;*/
}

.trajectories-banner {
  width: 100%;
}

.trajectories-text {
  font-size: 12px;
  font-weight: bold;
}

</style>
